<template>
    <modal :show.sync=show modalClasses="property-unit-modal" :hide-footer="true">
        <div style="max-width: 1400px !important;">        
            <div class="d-flex align-items-start mb-2" v-if="project">
                <el-image
                    style="width: 95px; height: 95px"
                    class="rounded mr-2"
                    :src="project.project_cover_image"
                    fit="cover"
                ></el-image>
                <b-row>
                    <b-col cols="12" class="mb-3">
                        <b-row class="d-flex align-items-center">
                            <b-col md="auto" cols="12" class="d-flex align-items-center">
                                <h4 class="mb-0">{{ project.project_name }}</h4>
                            </b-col>
                            <svg xmlns="http://www.w3.org/2000/svg" class="mx-2 d-none d-md-block " width="6" height="6" viewBox="0 0 512 512"><path fill="#73839C" d="M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208Z"/></svg>
                            <b-col md="auto" cols="12" class="d-flex align-items-center">
                                <p>{{ project.project_location }}</p>
                            </b-col>
                            <svg xmlns="http://www.w3.org/2000/svg" class="mx-2 d-none d-md-block " width="6" height="6" viewBox="0 0 512 512"><path fill="#73839C" d="M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208Z"/></svg>
                            <b-col md="auto" cols="4" class="d-flex align-items-center">
                                <p>{{ project.unit_total}} units</p>
                            </b-col>
                            <svg xmlns="http://www.w3.org/2000/svg" class="mx-2 d-none d-md-block " width="6" height="6" viewBox="0 0 512 512"><path fill="#73839C" d="M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208Z"/></svg>
                            <b-col md="auto" cols="8" class="d-flex align-items-center">
                                <p v-if="project.project_stage_id === 1">Under Construction</p>
                                <p v-else>Completed</p>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="auto" md="2">
                        <p class="text-xs">Date of Completion</p>
                        <p>{{ project.project_completion_date | dateFormatString }}</p>
                    </b-col>
                    <b-col cols="auto" md="2">
                        <p class="text-xs">Lease Type</p>
                        <p v-if="project.project_lease_type_id === 1">Freehold</p>
                        <p v-else>Leasehold</p>
                    </b-col>
                    <b-col cols="auto" md="2">
                        <p class="text-xs">Booking Fee</p>
                        <p>N/A</p>
                    </b-col>
                    <b-col cols="auto" md="3">
                        <p class="text-xs">Developer</p>
                        <p>{{ project.project_developer }}</p>
                    </b-col>
                    <b-col cols="auto" md="2">
                        <p class="text-xs">Buyer Discount</p>
                        <el-button type="text" class="py-0" disabled>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 512 512"><path fill="#5D79E3" d="M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480v-83.6c0-4 1.5-7.8 4.2-10.7l167.6-182.9c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8l-88.3-44.2C7.1 311.3.3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"/></svg>
                            Send a message
                        </el-button>
                    </b-col>
                </b-row>
            </div>
            <b-row class="d-flex justify-content-between mt-4 mb-3">
                <b-col cols="3">
                    <h4>Select Unit</h4>
                </b-col>
                <b-col cols="9" class="d-flex flex-row-reverse">
                    <div class="d-flex">
                        <!-- <span class="mr-2"><b-icon icon="square-fill" :style="{ 'color': UNIT_COLOR['Open']}"></b-icon> Open</span>
                        <span class="mr-2"><b-icon icon="square-fill" :style="{ 'color': UNIT_COLOR['Reserved']}"></b-icon> Reserved</span>
                        <span class="mr-2"><b-icon icon="square-fill" :style="{ 'color': UNIT_COLOR['Booked']}"></b-icon> Booked</span>
                        <span class="mr-2"><b-icon icon="square-fill" :style="{ 'color': UNIT_COLOR['Locked']}"></b-icon> Locked</span>
                        <span class="mr-2"><b-icon icon="square-fill" :style="{ 'color': UNIT_COLOR['Sold']}"></b-icon> Sold</span>
                        <span class="mr-4"><b-icon icon="square-fill" :style="{ 'color': UNIT_COLOR['Not Available']}"></b-icon> Not Available</span> -->
                        <el-switch
                        v-model="show_eligible_only"
                        class="mx-2"
                        active-color="#0BC196">
                    </el-switch>
                    Only show eligible unit
                    </div>
                </b-col>
            </b-row>
            <div v-if="unit_by_level.length === 0">No Units Found.</div>
            <div v-else>        
                <b-row class="d-flex align-items-center mb-2 flex-grow-1" v-for="(level, index) in unit_by_level" :key="index">
                    <b-col md="1" class="text-center text-md-left" v-if="level.length > 0">
                        <h4>Level {{ level[0].floor_sort }}</h4>
                        <p class="font-xs text-muted">{{level[0].built_up}} sqft</p>
                    </b-col>
                    <b-col md="11">
                        <b-row>
                            <b-col cols="6" md="2" v-for="(unit, index) in level" :key="index">
                                <a href="javascript:void(0)" @click="selectUnit(unit)">
                                    <b-card class="p-3 mb-2" no-body 
                                        :style="{
                                            'color': 'white',
                                            'background': UNIT_COLOR[unit.available_status ],
                                            'cursor': unit.available_status === 'Open' ? 'pointer' : 'not-allowed'
                                        }">
                                        <p class="font-weight-600 text-white">{{ unit.available_status }}</p>
                                        <p class="font-weight-bold">RM {{ unit.unit_price | moneyFormatter }}</p>
                                        <p class="text-xs">{{ unit.unit_no }}</p>
                                        <div class="m-0 p-0 text-right">
                                            <p class="h2 p-0 my--2"
                                            v-if="parseFloat(current_eligibility.max_eligibility) >= parseFloat(unit.unit_price)"
                                            ><b-icon icon="check-circle-fill" variant="success" v-b-tooltip.hover="'Eligible'"></b-icon></p>
                                            <p class="h2 p-0 my--2" v-else><b-icon icon="x-circle-fill" variant="danger" v-b-tooltip.hover="'Not Eligible'"></b-icon></p>
                                        </div>
                                    </b-card>
                                </a>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
        </div>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Image, Switch, Button } from 'element-ui'
import { mapActions, mapState } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { useProductStore } from '@/stores/productStore'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import {
    helperFunctionMixin,
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
} from '@/assets/js/httpImports.js'
import {UNIT_COLOR} from '@/assets/js/colors.js'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'

export default {
    props: {
        show_property:{
            type: Boolean
        },
        project:{
            type: Object
        },
        is_proposal:{
            type: Boolean,
            default: false
        }
    },
    components: {
        Modal,
        [Image.name]: Image,
        [Switch.name]: Switch,
        [Button.name]: Button,
    },
    mixins: [notifyFunctionMixin],
    data() {
        return {
            show_eligible_only: true,
            original_unit_listing_group_by_level: [],
            UNIT_COLOR:UNIT_COLOR,
        }
    },
    watch:{
        project(newVal){
            if(newVal){
                this.show_eligible_only = true
                this.original_unit_listing_group_by_level = JSON.parse(JSON.stringify(newVal.unit_listing_group_by_level));
            }
        }
    },
    computed: {
        unit_by_level(){
            if(this.project){
                this.original_unit_listing_group_by_level = JSON.parse(JSON.stringify(this.project.unit_listing_group_by_level));
                if(this.show_eligible_only){
                    var has_available_units = false
                    for (let i = 0; i < this.original_unit_listing_group_by_level.length; i++) {
                        this.original_unit_listing_group_by_level[i] = this.original_unit_listing_group_by_level[i].filter(item => {
                            return parseFloat(this.current_eligibility.max_eligibility) >= parseFloat(item.unit_price);
                        });
                        if(this.original_unit_listing_group_by_level[i].length > 0){
                            has_available_units = true
                        }
                    }
                    if(has_available_units){
                        return this.original_unit_listing_group_by_level
                    }
                    return []
                }
                return this.original_unit_listing_group_by_level
            }
            return []
        },
        ...mapState(useCustomerStore, ['current_eligibility']),
        ...mapState(useProductStore, ['current_product_data']),
        show: {
            get() {
                return this.show_property
            },
            set(newVal) {
                this.$emit('update:show_property', newVal)
            },
        },
    },
    methods:{
        ...mapActions(useProductStore, ['createPropertyProduct']),
        async selectUnit(unit){
            // check if its a proposal product selection
            if(this.is_proposal){
                let data = {
                    project: this.project,
                    unit: unit
                }
                initialProposalEventBus.$emit('selected-proposal-unit', data)
                return
            }

            if( unit.available_status !== 'Open'){
                return
            }

            if(!this.current_product_data.hasOwnProperty('banks') || this.current_product_data.banks.length === 0){
                this.errorFunction(null, 'Please select a bank.')
            }else{
                useProductStore().$patch((state) => {
                    state.current_product_data = { 
                        ...state.current_product_data, 
                        project: this.project,
                        unit: unit,
                    }
                })
                try{
                    await this.createPropertyProduct()
                    this.notifySuccess('<b>Draft </b> - Successfully Created.')
                    solutionEventBus.$emit('show-summary-selections')
                    
                    const currentQuery = { ...this.$route.query };
                    delete currentQuery.bank_code;
                    delete currentQuery.product_id;
                    delete currentQuery.project_id;
                    this.$router.replace({query: currentQuery,},() => {})

                    this.$emit('update:show_property', false)
                }catch(e){
                    this.errorFunction(null, e)
                }
            }
        }
    }
}
</script>